import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../commonComponents/translate';

function SkipStepButton(props) {
  const { t, onClick, className } = props;
  return (
    <button
      className={`skipStep-button ${className}`}
      type="button"
      id="skipStep"
      onClick={onClick}
    >
      {t('skip.step')}
    </button>
  );
}

SkipStepButton.propTypes = {
  t: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

SkipStepButton.defaultProps = {
  className: '',
};
export default translate(SkipStepButton);
